import { createSlice } from "@reduxjs/toolkit";

const initialState:any = {
    contactAttributes: [],
    autodropTime:0,
    selectedContact: ""
};

const contactAttributeSlice = createSlice({
    name: "contactAttributeSlice",
    initialState: initialState,
    reducers: {
        addContactAttributes(state, action) {
            let payload = action.payload;
            if(state.contactAttributes.length > 0) {
                let alreadyExists = state.contactAttributes.filter((contact:any) => contact.contactId === payload.contactId)[0]
                if(!alreadyExists) {
                    state.contactAttributes.push(payload);
                }
            } else {
                state.contactAttributes.push(payload);
            }
            state.selectedContact = payload.contactId
        },
        updateContactAttributes(state, action) {
            let payload = action.payload;
            state.contactAttributes = payload;
        },
        removeContactAttributes(state, action) {
            let payload = action.payload;
            state.contactAttributes = payload;
        },
        setSelectedContact(state, action) {
            let payload = action.payload;
            state.selectedContact = payload;
        },
        setAutodropTime(state, action) {
            let payload = action.payload;
            state.autodropTime = payload;
        },
        resetAutodropTime(state) {
            state.autodropTime = 0;
        }
    },
});

export const contactAttributeSliceAction = contactAttributeSlice.actions;
export default contactAttributeSlice.reducer;